export const APP_LEADS_ROUTE = "/leads";
export const COMPANY_LEADS_ROUTE = "/company-leads";
